import React, { useContext } from 'react';

import { Link as RouterLink } from 'react-router-dom';

import {
    Button,
    Card,
    CardContent,
    CardHeader,
    Divider,
    Grid,
    IconButton,
    Link,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Tooltip,
    Typography
} from '@mui/material';

import DeleteIcon from '@mui/icons-material/Delete';

import { NavContext, NavRoutes } from "../../../contexts";
import { UfficioContext } from '../UfficioContext';

const LinkRouter = props => <Link {...props} component={RouterLink} />;

export const ContattiList = ({
    disabled,
    onActionClick,
    ...props
}) => {

    const {
        getRouteTo,
        navigateTo,
    } = useContext(NavContext);

    const {
        state,
        setState,
    } = useContext(UfficioContext);

    const {
        ufficio,
        contatti,
    } = state;

    const deleteClickHandler = async (data) => {
        if (onActionClick)
            onActionClick("Delete", data);
    }

    const addClickHandler = async (data) => {
        if (onActionClick)
            onActionClick("Add", data);
    }

    const wizardClickHandler = async (data) => {
        if (onActionClick)
            onActionClick("Wizard", data);
    }

    const urlParams = new URLSearchParams(window.location.search);
    const solaLettura = /^true$/i.test(urlParams.get("solaLettura"));

    return (
        <>
            <Grid container spacing={2} sx={{ marginTop: 2 }}>
                <Grid item xs={12}>
                    <Card>
                        <CardHeader
                            sx={{
                                color: "white",
                                backgroundColor: "secondary.main",
                            }}
                            title={
                                <Grid container alignItems="center" justifyContent="space-between">
                                    <Grid item>
                                        <Typography variant="h6">Attributi</Typography>
                                    </Grid>

                                    <Grid item>
                                        <Button
                                            variant="contained"
                                            disableElevation
                                            color="info"
                                            disabled={disabled || solaLettura}
                                            onClick={wizardClickHandler}
                                            sx={{ marginRight: 2 }}
                                        >
                                            Editor
                                        </Button>
                                        {/* <Button
                                            variant="contained"
                                            disableElevation
                                            color="info"
                                            disabled={disabled || solaLettura}
                                            onClick={addClickHandler}
                                        >
                                            Aggiungi
                                        </Button> */}
                                    </Grid>
                                </Grid>
                            }
                        />
                        {/* <Divider />
                        <CardContent sx={{ padding: "0px !important" }}>
                            <Table>
                                <TableHead sx={{
                                    backgroundColor: "aliceblue",
                                }}>
                                    <TableRow>
                                        <TableCell style={{ width: "33%" }}>TIPO</TableCell>
                                        <TableCell style={{ width: "33%" }}>DESCRIZIONE</TableCell>
                                        <TableCell style={{ width: "33%" }}>ORDINE</TableCell>
                                        <TableCell align="right"></TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {
                                        contatti && contatti.length > 0 ?
                                            contatti?.sort((a, b) => a.ordine - b.ordine).map((contatto, index) => <TableRow key={index}>
                                                <TableCell style={{ width: "33%" }}>
                                                    <div sx={{
                                                        display: 'flex',
                                                        alignItems: 'center'
                                                    }}>
                                                        <Link
                                                            color="textPrimary"
                                                            onClick={() => window.open(getRouteTo(NavRoutes.Contatto, [ufficio.id, contatto.id]), "_blank").focus()}
                                                            sx={{ fontWeight: 700, cursor: "pointer" }}>
                                                            {contatto.tipoContatto?.nome}
                                                        </Link>
                                                    </div>
                                                </TableCell>
                                                <TableCell style={{ width: "33%" }}> 
                                                    <div sx={{
                                                        display: 'flex',
                                                        alignItems: 'center'
                                                    }}>
                                                        <Link
                                                            color="textPrimary"
                                                            onClick={() => window.open(getRouteTo(NavRoutes.Contatto, [ufficio.id, contatto.id]), "_blank").focus()}
                                                            sx={{ fontWeight: 700, cursor: "pointer" }}>
                                                            {contatto.descrizione}
                                                        </Link>
                                                    </div>
                                                </TableCell>
                                                <TableCell style={{ width: "33%" }}>
                                                    <div sx={{
                                                        display: 'flex',
                                                        alignItems: 'center'
                                                    }}>
                                                        {contatto.ordine}
                                                    </div>
                                                </TableCell>
                                                <TableCell align="right">
                                                    <IconButton
                                                        aria-label="delete"
                                                        disabled={disabled}
                                                        onClick={() => deleteClickHandler(contatto)}>
                                                        <Tooltip title="elimina attributo">
                                                            <DeleteIcon />
                                                        </Tooltip>
                                                    </IconButton>
                                                </TableCell>
                                            </TableRow>)
                                            :
                                            <TableRow>
                                                <TableCell align="center" colSpan="100%"
                                                    sx={{ padding: 8, color: "primary.main", fontWeight: "bold" }}>
                                                    NON SONO PRESENTI ATTRIBUTI
                                                </TableCell>
                                            </TableRow>
                                    }
                                </TableBody>
                            </Table>
                        </CardContent> */}
                    </Card>
                </Grid>
            </Grid>
        </>
    );
}